module.exports = __webpack_public_path__ + "media/images/icon-signature-white-b0e7fa65.svg";